// Helper function to get URL query parameters
export const getQueryParams = () => {
  return Object.fromEntries(new URLSearchParams(window.location.search));
};
